<template>
    <v-card elevation="1">
        <div v-if="hasMerchants">
            <v-card class="custom-table-ui header-filters pa-3" flat>
                <form class="form-data">
                    <v-row>
                        <v-col md="4" lg="3" cols="12" class="mr-auto">
                            <v-text-field v-model="dataTable.search" label="Search here" placeholder="Search here" prepend-inner-icon="search" solo dense flat color="primaryTextColor" clearable hide-details />
                        </v-col>
                        <v-col md="3" class="mt-0 pt-0" lg="2" cols="12" v-if="filters.classification.show">
                            <v-subheader class="px-0">Classification</v-subheader>
                            <v-select
                                id="merchant"
                                v-model="dataTable.merchantClassification"
                                @change="filterData"
                                item-text="text"
                                item-value="value"
                                :items="merchantClassificationItems"
                                :class="{ disabled: filters.classification.disabled }"
                                solo
                                dense
                            ></v-select>
                        </v-col>
                        <v-col md="3" class="mt-0 pt-0" lg="2" cols="12" v-if="filters.batchNumber.show">
                            <v-subheader class="px-0">Batch Number</v-subheader>
                            <!-- <v-autocomplete
                            v-model="dataTable.batch_number"
                            @blur="filterData"
                            ref="batchNumbers"
                            :items="batchNumbersList"
                            item-text="text"
                            item-value="value"
                            label="Select batch number"
                            placeholder="Select batch number"
                            :class="{ disabled: this.batchNumber != '' && this.module == 'import' }"
                            solo
                            dense
                        >
                        </v-autocomplete> -->
                            <v-text-field v-model="dataTable.batchNumber" :class="['mt-0 pt-0', { disabled: filters.batchNumber.disabled }]" hide-details type="text" solo dense></v-text-field>
                        </v-col>
                        <v-col md="3" lg="2" cols="12" v-if="filters.minPoints.show">
                            <v-row>
                                <v-subheader class="ml-0">Minimum Points</v-subheader>
                                <v-col class="mt-0 pt-0" md="6" lg="6" cols="12">
                                    <v-text-field
                                        v-model="dataTable.minPointsStart"
                                        @keypress="$validate.minPoints"
                                        @paste.prevent
                                        :min="1"
                                        :class="['mt-0 pt-0', { 'is-invalid': errors['filters.point_range_start'] }]"
                                        :error-messages="errors['filters.point_range_start']"
                                        hide-details="auto"
                                        type="number"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col class="mt-0 pt-0" md="6" lg="6" cols="12">
                                    <v-text-field
                                        v-model="dataTable.minPointsEnd"
                                        @keypress="$validate.minPoints"
                                        @paste.prevent
                                        :min="1"
                                        :class="['mt-0 pt-0', { 'is-invalid': errors['filters.point_range_end'] }]"
                                        :error-messages="errors['filters.point_range_end']"
                                        class="mt-0 pt-0"
                                        hide-details="auto"
                                        type="number"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </form>
            </v-card>
            <v-divider></v-divider>
            <v-card v-if="dataTable.selected.length" flat class="download-selected pa-4 d-flex">
                <b class="success--text my-auto">{{ dataTable.selected.length }} Selected Merchant/Branch QR</b>

                <v-btn :class="[{ disabled: isDisabledDownloadButton }, 'ml-auto']" color="success" @click="downloadSelected"> <v-icon left> mdi-tray-arrow-down </v-icon> Download Selected</v-btn>
            </v-card>
            <v-data-table
                class="custom-table-ui no-loading-bar"
                v-model="dataTable.selected"
                :show-select="true"
                item-key="id"
                :headers="dataTable.headers"
                :items="dataTable.data"
                :loading="dataTable.loading"
                loader-height="0"
                loading-text="Loading data..."
                :page.sync="dataTable.currentPage"
                :items-per-page.sync="dataTable.itemLength"
                :sort-by.sync="dataTable.sortBy"
                :sort-desc.sync="dataTable.sortDesc"
                :custom-sort="(items) => items"
                hide-default-footer
                checkbox-color="#66CB9F"
            >
                <template v-slot:[`item.mobile`]="{ item }">
                    {{ item.mobile }}
                </template>

                <template v-slot:[`header.min_points`]="{ header }">
                    {{ header.text }}
                    <v-tooltip bottom max-width="160px">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small>mdi-alert-circle-outline</v-icon>
                        </template>

                        <div class="tooltip-wrapper">
                            <span>{{ header.tooltip }}</span>
                        </div>
                    </v-tooltip>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <div :class="['status', item.status.toLowerCase()]">{{ item.status | uppercaseFirst }}</div>
                </template>

                <template v-slot:[`item.primary_merchant_name`]="{ item }">
                    <div v-if="item.primary_merchant">{{ item.primary_merchant.name }}</div>
                </template>

                <!-- Start dates: Do not add whitespace/newline -->
                <template v-slot:[`item.created_at`]="{ item }">{{ item.created_at | formatDate }}</template>
                <template v-slot:[`item.activate_at`]="{ item }">{{ item.activate_at | formatDate }}</template>
                <template v-slot:[`item.deactivate_at`]="{ item }">{{ item.deactivate_at | formatDate }}</template>
                <template v-slot:[`item.activated_at`]="{ item }">{{ item.activated_at | formatDate }}</template>
                <template v-slot:[`item.deactivated_at`]="{ item }">{{ item.deactivated_at | formatDate }}</template>
                <!-- End dates: Do not add whitespace/newline -->

                <template v-slot:[`item.actions`]="{ item }">
                    <div class="action">
                        <v-menu min-width="160px">
                            <template v-slot:activator="{ on: menu, attrs }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on: tooltip }">
                                        <v-icon class="mr-2" v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-dots-vertical</v-icon>
                                    </template>
                                    <span>More</span>
                                </v-tooltip>
                            </template>

                            <v-list>
                                <v-list-item v-if="isPermitted(userInfo.permissions, 'merchants-show')" dense @click="viewDetails(item.uuid)">View Details</v-list-item>
                                <v-list-item v-if="isPermitted(userInfo.permissions, 'merchants-update')" dense @click="editDetails(item.uuid)">Edit Details</v-list-item>
                                <v-list-item dense @click="sendQr(item)">Send QR</v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
            </v-data-table>

            <v-card class="data-table-footer d-flex align-center justify-space-between flex-wrap border-radius-10 py-0" flat color="primaryBackgroundColor" v-if="module != 'import'">
                <div class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 d-flex align-center justify-center py-2 px-3">
                    <span>Show</span>
                    <v-select class="item-length mx-2" v-model="dataTable.itemLength" :items="[10, 20, 50, 100]" solo dense flat background-color="secondaryBackgroundColor" hide-details />
                    <span class="px-0" md="auto" sm="auto" cols="auto">items per page</span>
                </div>
                <v-pagination class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 justify-center py-2" v-model="dataTable.currentPage" :length="dataTable.totalPages" :total-visible="7"></v-pagination>
            </v-card>
        </div>
        <div v-else class="merchant-empty text-center">
            <div>
                <div class="mt-n9" v-html="require(`!html-loader!@/assets/img/cart.svg`)"></div>
                <div class="font-weight-bold">There are no Merchants to display.</div>
                <small>You’ve not added any merchant yet.</small>
            </div>
        </div>
        <SendQRForm v-bind="sendQRFormDialog" @close="sendQRFormDialog = { ...sendQRFormDialog, show: false, data: {} }" />
    </v-card>
</template>

<script>
import SendQRForm from '../Core/SendQrForm.vue';

export default {
    name: 'MerchantDataTable',
    components: {
        SendQRForm
    },
    props: {
        details: {
            type: Object,
            default: () => {}
        },
        module: {
            type: String,
            default: 'merchants'
        },
        customFilters: Object,
        perPage: {
            type: Number
        }
    },
    data() {
        return {
            // range: [0, 0],
            hasMerchants: true,
            dataTable: {
                loading: true,
                search: '',
                merchantClassification: '',
                batchNumber: null,
                minPointsStart: null,
                minPointsEnd: null,
                itemLength: 10,
                currentPage: 1,
                totalPages: 1,
                selected: [],
                sortBy: [],
                sortDesc: [],
                headers: [
                    { text: 'Partner Name', value: 'partner', fixed: true },
                    { text: 'UUID', value: 'uuid', width: '300' },
                    { text: 'Store Name', value: 'name' },
                    { text: 'Mobile Number', value: 'mobile', width: '180' },
                    { text: 'Merchant Address', value: 'address' },
                    { text: 'Status', value: 'status' },
                    { text: 'municipality', value: 'municipality' },
                    { text: 'Province', value: 'province' },
                    { text: 'Location', value: 'location' },
                    { text: 'Min Points', value: 'min_points', tooltip: 'Minimum points required to avail the rewards or promotion.' },
                    { text: 'Type', value: 'type' },
                    { text: 'Classification', value: 'classification' },
                    { text: 'Batch Number', value: 'batch_number' },
                    { text: 'Longitude ', value: 'longitude' },
                    { text: 'Latitude ', value: 'latitude' },
                    { text: 'Primary (if branch)', value: 'primary_merchant_name' },
                    { text: 'Enrollment Date', value: 'created_at' },
                    { text: 'Activation Date', value: 'activate_at' },
                    { text: 'Deactivation Date', value: 'deactivate_at' },
                    { text: 'Date Activated', value: 'activated_at' },
                    { text: 'Date Deactivated', value: 'deactivated_at' },
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        class: ['sticky', 'right'],
                        cellClass: ['sticky', 'right']
                    }
                ],
                data: []
            },
            sendQRFormDialog: { show: false, action: '', data: {} },
            isBusyBatchNumbers: true
        };
    },
    computed: {
        filters() {
            const filters = {
                classification: {
                    show: true,
                    disabled: false
                },
                batchNumber: {
                    show: true,
                    disabled: false
                },
                minPoints: {
                    show: true,
                    disabled: false
                },
                actions: {
                    show: true,
                    disabled: false
                }
            };

            return { ...filters, ...this.customFilters };
        },
        isDisabledDownloadButton() {
            return this.$cookies.get('asyncTaskIDPoll') && this.$cookies.get('asyncTaskIDPoll') != null;
        },
        list() {
            return this.$store.getters['merchants/getMerchantsList'];
        },
        batchNumbersList() {
            let arr = [];
            if (this.filters.batchNumber.value != '' && this.module == 'import') {
                arr.push({ text: this.batchNumber, value: this.batchNumber });
            } else {
                for (let i = 0; i <= 1000; i++) {
                    arr.push({ text: i, value: i });
                }
            }
            return arr;
        },
        merchantClassificationItems() {
            let data = this.$store.getters['options/getMerchantClassifications'],
                list = [{ value: '', text: 'All Classifications' }];

            for (var key in data) {
                list.push({ value: data[key], text: key });
            }
            return list;
        }
    },

    watch: {
        filters: {
            immediate: true,
            // deep: true,
            handler(filters) {
                this.dataTable.batchNumber = filters.batchNumber.value;

                // Remove actions
                if (!filters.actions.show) {
                    this.dataTable.headers.pop();
                }
            }
        },
        perPage: {
            immediate: true,
            handler(value) {
                if (value) {
                    if (value != 10) {
                        this.dataTable.itemLength = value;
                    } else {
                        this.getData({ cancel_current_api_call: this.module == 'import' ? false : true });
                    }
                }
            }
        },
        merchantClassificationItems: {
            immediate: true,
            handler() {
                if (this.filters.classification.value) {
                    this.dataTable.merchantClassification = this.filters.classification.value;
                }
            }
        },
        list(to) {
            if (to) {
                this.dataTable.loading = false;
                this.dataTable.totalPages = to.meta.last_page;
                this.dataTable.data = to.data; // to.data
                window.scrollTo(0, 0);
            }
        },
        'dataTable.search'() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.dataTable.currentPage = 1;
                this.getData({ cancel_current_api_call: true });
            }, 300);
        },
        'dataTable.batchNumber'() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.dataTable.currentPage = 1;
                this.getData({ cancel_current_api_call: this.module == 'import' ? false : true });
            }, 300);
        },
        'dataTable.minPointsStart'() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.dataTable.currentPage = 1;
                this.getData({ cancel_current_api_call: true });
            }, 300);
        },
        'dataTable.minPointsEnd'() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.dataTable.currentPage = 1;
                this.getData({ cancel_current_api_call: true });
            }, 300);
        },
        'dataTable.itemLength'() {
            this.dataTable.currentPage = 1;
            this.getData({ cancel_current_api_call: this.module == 'import' ? false : true });
        },
        'dataTable.currentPage'() {
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.sortBy'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];

            if (sortBy != undefined && sortDesc != undefined && sortDesc != true) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        },
        'dataTable.sortDesc'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];

            if (sortBy != undefined && sortDesc != undefined) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        }
    },
    methods: {
        initiate() {
            // Let watcher call merchants list API if from import module
            if (this.module != 'import') {
                this.getData();
            }
            this.getMerchantClassificationOptions();
        },
        getData(payload) {
            let { cancel_current_api_call } = payload || {};

            if (cancel_current_api_call) {
                this.$api.cancelCurrentApiCall();
            }

            this.dataTable.loading = true;

            // this.dataTable.itemLength = this.dataTable.itemLength > 0 ? this.dataTable.itemLength : 10;

            const { search, itemLength, currentPage, sortBy, sortDesc } = this.dataTable;

            let id = '';
            let url = 'merchants/fetchMerchants';

            // Check if viewing branches using selected merchant
            if (this.filters.classification.value && this.$route.params.id) {
                id = this.$route.params.id;
                url = `merchants/fetchMerchantBranches`;
            } else if (this.userInfo.role.id == 'MERCHANT') {
                if (this.userInfo.merchant && this.userInfo.merchant.uuid) {
                    id = this.userInfo.merchant.uuid;
                }
                url = `merchants/fetchMyMerchantBranches`;
            }

            this.$store
                .dispatch(url, {
                    config: {
                        params: {
                            'filters[keyword]': search || undefined,
                            per_page: itemLength,
                            page: currentPage,
                            sort_by: sortBy[0],
                            order: sortDesc[0] != undefined ? (!sortDesc[0] ? 'asc' : 'desc') : undefined,
                            'filter_classifications[]': this.dataTable.merchantClassification || undefined,
                            'filters[point_range_start]': this.dataTable.minPointsStart || undefined,
                            'filters[point_range_end]': this.dataTable.minPointsEnd || undefined,
                            'filters[batch_number]': this.dataTable.batchNumber || undefined,
                            'appends[0]': 'primary_merchant'
                        }
                    },
                    id: id
                })
                .then(() => {})
                .catch((error) => {
                    this.dataTable.loading = false;
                    this.notification({ type: 'error', message: error.response.data?.message || error.response.statusText });
                });
        },
        getMerchantClassificationOptions() {
            this.$store.dispatch('options/fetchMerchantClassifications');
        },
        confirmAction({ action, data }) {
            // Set modal title starting sentence
            switch (action) {
                case 'delete':
                    data.modalTitle = 'Delete Merchant?';
                    data.modalDescription = 'Are you sure you want to delete this merchant?';
                    break;
            }

            this.confirmDialog = { show: true, action, data };
        },
        action({ action, data }) {
            switch (action) {
                case 'add':
                    // get
                    this.contentManagementFormDialog = { show: true, action, data: {} };
                    break;
                case 'edit':
                    this.confirmDialog.show = false;
                    this.contentManagementFormDialog = { show: true, action, data };
                    break;
                case 'delete':
                    this.confirmDialog.loading = true;
                    this.deletePage(data);
                    break;
                default:
                    this.contentManagementFormDialog = { show: true, action, data: data || {} };
                    break;
            }
        },
        deletePage(data) {
            this.confirmStatusLoading = true;
            this.$store
                .dispatch('merchants/deleteMerchant', { id: data.uuid })
                .then((response) => {
                    this.confirmStatusLoading = false;
                    this.getData();

                    this.confirmDialog.show = false;
                    this.notification({ type: 'success', message: response.message });
                })
                .catch((error) => {
                    this.confirmStatusLoading = false;
                    this.confirmDialog.show = false;

                    if (error.response && error.response.data) {
                        let text = [];

                        if (error.response.data.errors) {
                            let errors = Object.keys(error.response.data.errors);
                            // Loop each field with errors
                            errors.forEach((key) => {
                                text = [...text, `${error.response.data.errors[key]} <br/>`];
                            });
                        }

                        this.$notify({
                            group: 'main-notifications',
                            type: 'error',
                            duration: 5000,
                            title: 'Merchants',
                            text: text.length > 0 ? text.toString().replace(',', '') : error.response.data.message || error.response.data.data.message || error.response.statusText || 'Merchants Delete Error'
                        });
                    }
                });
        },
        filterData() {
            this.getData({ cancel_current_api_call: true });
        },
        downloadSelected() {
            // Download selected items
            // this.$store.dispatch('merchants/downloadMerchantsQR')
            const selectedMerchantIDs = [];
            this.dataTable.selected.forEach((item) => {
                // console.log(item[value][0]);
                selectedMerchantIDs.push(item.uuid);
            });

            this.$store
                .dispatch('merchants/processDownloadAsyncMerchantsQR', {
                    data: {
                        merchant_uuids: selectedMerchantIDs || undefined,
                        output_format: 'PDF'
                        // responseType: 'blob'
                    }
                })
                .then((response) => {
                    this.$cookies.set('asyncTaskIDPoll', window.btoa(response.data.id));
                    let classificationModule = this.dataTable.merchantClassification == 'BRANCH' ? 'Branches' : 'Merchants';

                    // Set asyncTaskModule
                    this.$cookies.set('asyncTaskModule', classificationModule);

                    this.notification({
                        type: 'success',
                        title: `${classificationModule} - QR Download`,
                        message: 'QR Generation In-Progress. Please wait for the process to complete. Do not logout or close this window.'
                    });

                    this.$eventBus.$emit('check-merchants-qr-status');
                    // this.notification({ type: 'success', message: response.message || 'Successfully downloaded selected QR' });
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        let text = [];
                        if (error.response.data.errors) {
                            let errors = Object.keys(error.response.data.errors);
                            // Loop each field with errors
                            errors.forEach((key) => {
                                text = [...text, `${error.response.data.errors[key]} <br/>`];
                            });
                        }

                        let classification = this.dataTable.merchantClassification == 'BRANCH' ? 'Branches' : 'Merchants';

                        this.$notify({
                            group: 'main-notifications',
                            type: 'error',
                            duration: 5000,
                            title: `${classification} - QR Download`,
                            text: text.length > 0 ? text.toString().replace(',', '') : error.response.data.data.message || error.response.data.message || error.response.statusText
                        });
                    }
                });

            // console.log(this.dataTable.selected, 'selected merchants');
        },
        viewDetails(id) {
            // View Details
            this.$router.push(this.navigation('to', ['view', id], false));
        },
        editDetails(id) {
            // Edit Details
            this.$router.push(this.navigation('to', ['edit', id], false));
        },
        sendQr(item) {
            this.sendQRFormDialog = { show: true, data: { id: item.uuid, classification: item.classification, merchantName: item.name } };
            // Send QR
        }
    },
    mounted() {
        this.initiate();
    }
};
</script>

<style lang="scss" scoped>
.merchant-empty {
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.status {
    font-weight: 500;
}

::v-deep table {
    tr {
        td:empty::after {
            content: 'N/A';
            color: #425466;
            opacity: 0.5;
        }
    }
}
</style>
